import React, { Fragment, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import cn from 'classnames';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { Grid, Column } from 'components/Layout';
import CircleComplete from 'components/Icons/CircleComplete';
import {
  checkPreviousAction,
} from 'actions/workflow';

import style from './style.scss';

const SignLoanDocument = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const applicationId = useSelector((state) => get(state, 'workflow.attributes.entityId') || '');

  useEffect(() => {
    const key = searchParams.get('key');
    if (!key) {
      navigate('/fsl/application', { replace: true });
    } else if (!props.applicationId) {
      dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/fsl/${key}/checkin`,
        success: (response) => {
          const routeUrl = response.data && response.data.url;
          navigate(routeUrl);
        },
        fail: () => {
          navigate('/fsl/application', { replace: true });
        },
      }));
    }
  }, []);

  return (
    <Fragment>
      <Header />
      <section className="container">
        <div className={cn('grid-container fluid', style['borrowers-message'])}>
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">
              {applicationId ? (
                <div className="small-12 large-8 large-offset-2" style={{ textAlign: 'left', padding: '0 3.4rem' }}>
                  <p className="mb-0 p-large"><b>Application ID:</b> {applicationId}</p>
                </div>
              ) : null}
              <Column className="small-12 large-8 large-offset-2">
                <CircleComplete />
                <h2>That’s it. You’re all set!</h2>
                <p className="p-xlarge">If you have any questions please call 949-694-5001</p>
              </Column>
            </Grid>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default SignLoanDocument;
